import React from "react";
import { inject, observer } from "mobx-react";
// import { create } from "mobx-persist";
import { Alert, Glyphicon, Button, Collapse } from "react-bootstrap";
import { DescriptiveMetaData } from "../../components/detail/DescriptiveMetaData";
import { RelatedObjects } from "../../components/detail/RelatedObjects";
import { RelatedFrameworksWithCubes } from "../../components/detail/RelatedFrameworksWithCubes";
import { CubeRepresentation } from "../../components/detail/CubeRepresentation";
import { CubeCompare } from "../../components/detail/CubeCompare";
import { MatchingCubes } from "../../components/detail/MatchingCubes";
import { CubeLinkVariables } from "../../components/detail/CubeLinkVariables";
import { CombinationRepresentation } from "../../components/detail/CombinationRepresentation";
import { GenericListRepresentation } from "../../components/detail/GenericListRepresentation";
import { CubeQueryWizardButton } from "../../components/detail/CubeQueryWizard/CubeQueryWizardButton";
import VisContainer from "../../components/vis/container/VisContainer";
import Mapping from "../../components/vis/mapping/Mapping";
import MappingDefinition from "../../components/vis/mapping/MappingDefinition";
import TemplateRepresentation from "../../components/vis/template/TemplateRepresentation";
import FacetRepresentation from "../../components/vis/facet/FacetRepresentation";
import { RelatedObjectItem } from "../../components/detail/RelatedObjectItem";
import { StoreContext } from "../../contexts/StoreContext";
import { SimilarObjects } from "../../components/detail/SimilarObjects";
import EnvironmentUtils from "src/utils/EnvironmentUtils.js";
import ActivityNavigation from "../../components/navigation/ActivityNavigation";

@inject(
  "previewStore",
  "searchStore",
  "http",
  "cubeQueryWizardStore",
  "navigationStore",
  "popupStore",
  "multiSearchStore"
)
@observer
export default class PreviewPage extends React.Component {
  constructor(props) {
    super(props);

    this.cubeVariablesMappingRef = React.createRef();
    this.templateRepresentationRef = React.createRef();
    this.cubeRepresentationRef = React.createRef();
    this.cubeComparisonRef = React.createRef();
    this.similarObjectsRef = React.createRef();
    this.relatedRef = React.createRef();
    this.descriptiveMetaDataRef = React.createRef();
    this.navRef = React.createRef();
    this.LinkedCubesRef = React.createRef();

    this.scrollTargets = {
      TemplateRepresentation: this.templateRepresentationRef,
      CubeRepresentation: this.cubeRepresentationRef,
      CubeComparison: this.cubeComparisonRef,
      SimilarObjects: this.similarObjectsRef,
      CubeVariablesMapping: this.cubeVariablesMappingRef,
      Related: this.relatedRef,
      LinkedCubes: this.LinkedCubesRef,
    };

    this.state = {
      mainHierarchyTree: true,
    };
  }

  hasTemplateRepresentation = () => {
    const { getEntityData } = this.context;
    const entityData = getEntityData.item;
    if (
      !entityData ||
      !entityData.navigationLookupResult ||
      !entityData.navigationLookupResult.navigationLookupRootItem ||
      !entityData.navigationLookupResult.navigationLookupRootItem.items ||
      !entityData.navigationLookupResult.navigationLookupRootItem.items.length
    ) {
      return false;
    }
    const cubeToTableItem =
      entityData.navigationLookupResult.navigationLookupRootItem.items.find(
        (item) => item.object.type === "CubeToTable"
      );
    if (!cubeToTableItem || !cubeToTableItem.items) return false;

    const hasTable =
      cubeToTableItem.items.filter((item) => item.object.type === "Table")
        .length > 0;
    if (!hasTable) {
      return false;
    }

    return true;
  };

  handleQueryWizardButtonClick = () => {
    this.props.cubeQueryWizardStore.hasTemplateRepresentation =
      this.hasTemplateRepresentation();
    this.props.cubeQueryWizardStore.toggleShowQueryWizard(
      /* state = */ true,
      /* loadCombinations = */ true
    );
  };
  componentWillMount = () => {
    const { clearEntityData } = this.context;
    if (this.props.display) {
      clearEntityData();
    }
  };

  componentDidMount = () => {
    const { clearEntityData } = this.context;
    if (this.props.display) {
      clearEntityData();
    }
  };

  componentWillUnmount = () => {
    const { clearEntityData, setType, setTid } = this.context;
    clearEntityData(); // having it in componentDidMount was not enough
    setType();
    setTid();
  };
  componentDidUpdate = async (prevProps, prevState) => {
    const {
      clearEntityData,
      fetchEntityDetails,
      initAdditionalQueryParams,
      setDisplayPublishedCubesOfFramework,
      setPrevTid,
      setPrevType,
      setCanRefresh,
      canRefresh,
      type,
      tid,
      prevTid,
    } = this.context;
    const { setNavigationTabs } = this.props.navigationStore;
    if (type && type.toLowerCase() === "framework") {
      setDisplayPublishedCubesOfFramework(this.readPublishedUrlParam());
    }
    if (tid !== prevTid && type && tid && canRefresh) {
      clearEntityData();
      initAdditionalQueryParams(type);
      if (this.context === this.props.popupStore)
        setNavigationTabs({ type: type, tid: tid });
      fetchEntityDetails(type, tid);
      setCanRefresh(true);
      setPrevType(type);
      setPrevTid(tid);
    }
    if (type === "Cube") {
      this.props.cubeQueryWizardStore.hasTemplateRepresentation =
        this.hasTemplateRepresentation();
    }
    if (type === "CubeHierarchy") {
      this.props.cubeQueryWizardStore.hasTemplateRepresentation = true;
    }

    if (this.props.cubeQueryWizardStore.hasTemplateRepresentation) {
      // if it has TR, it must also have combinations
      this.props.cubeQueryWizardStore.hasCombinations = true;
    }
  };

  readPublishedUrlParam() {
    if (window.location.href.match("published")?.length) {
      let displayPublished = window.location.href.split("published=")[1];
      if (displayPublished.includes("&")) {
        displayPublished = displayPublished.split("&")[0];
      }
      return displayPublished !== "false";
    }
    return true;
  }

  componentWillUnmount() {
    const { setUserProfileChanged } = this.props.searchStore;
    setUserProfileChanged(false);
  }

  renderDescriptiveMetadata = (entityData) => {
    return (
      <div ref={this.descriptiveMetaDataRef}>
        <DescriptiveMetaData {...entityData} />
      </div>
    );
  };

  renderRelatedCubes = (entityData) => {
    // frameworks with nested cube types with nested cubes
    return [
      "Variable",
      "Member",
      "Subdomain",
      "VariableSet",
      "Combination",
    ].indexOf(entityData.object.type) > -1 ? (
      <RelatedFrameworksWithCubes
        navigationLookupBuckets={
          entityData &&
          entityData.navigationLookupResult &&
          entityData.navigationLookupResult.navigationLookupBuckets
            ? entityData.navigationLookupResult.navigationLookupBuckets
            : undefined
        }
        searchMatrixKey={"relFwC"}
      />
    ) : null;
  };

  renderHintOnProfileForNoRelatedData = (entityData) => {
    let someContentFound = false;
    try {
      if (
        entityData &&
        entityData.navigationLookupResult &&
        entityData.navigationLookupResult.navigationLookupBuckets
      ) {
        const buckets = {
          ...entityData.navigationLookupResult.navigationLookupBuckets,
        };
        for (const bucket in buckets) {
          if (
            buckets[bucket] &&
            buckets[bucket].totalCountOfObjects &&
            buckets[bucket].totalCountOfObjects > 0
          ) {
            someContentFound = true;
            break;
          }
        }
      }
      if (
        entityData &&
        entityData.navigationLookupResult &&
        entityData.navigationLookupResult.navigationLookupRootItem &&
        entityData.navigationLookupResult.navigationLookupRootItem.items &&
        entityData.navigationLookupResult.navigationLookupRootItem.items.length
      ) {
        someContentFound = true;
      }
      if (entityData && entityData.otherInformation) {
        const otherInformation = { ...entityData.otherInformation };
        for (const info in otherInformation) {
          if (
            otherInformation[info] &&
            Array.isArray(otherInformation[info]) &&
            otherInformation[info].length > 0
          ) {
            someContentFound = true;
            break;
          } else if (
            otherInformation[info] &&
            !Array.isArray(otherInformation[info]) &&
            typeof otherInformation[info] === "object" &&
            otherInformation[info] != null
          ) {
            someContentFound = true;
            break;
          }
        }
      }
    } catch (err) {
      // as this is conveniency mean, let's just ignore in case of error, maybe our checks are not proper
      someContentFound = true;
    }

    return someContentFound ? null : (
      <Alert bsStyle="info" className="warning-user-profile">
        <div>
          <Glyphicon glyph="info-sign" />
          This object has no related objects. Changing the profile may reveal
          connections in different cube layers.
        </div>
      </Alert>
    );
  };

  entityDataHasCubeLinks = (entityData) => {
    if (
      entityData.object.type === "Cube" &&
      entityData.navigationLookupResult &&
      entityData.navigationLookupResult.navigationLookupRootItem &&
      entityData.navigationLookupResult.navigationLookupRootItem.items
    ) {
      const items =
        entityData.navigationLookupResult.navigationLookupRootItem.items;
      for (let i = 0; i < items.length; i += 1) {
        if (items[i].object.type === "CubeLink") return true;
      }
    }
    return false;
  };

  renderRepresentation = (entityData) => {
    return (
      <React.Fragment>
        {/* cube with cube structure items in a specific desired representation */}
        {entityData && entityData.object.type === "Cube" ? (
          <CubeRepresentation
            innerRef={this.cubeRepresentationRef}
            cubeQueryWizardStore={this.props.cubeQueryWizardStore}
            {...entityData}
            searchMatrixKey={"cubeReps"}
          />
        ) : null}

        {/* combination with combination items in a specific desired representation */}
        {entityData && entityData.object.type === "Combination" ? (
          <CombinationRepresentation
            {...entityData}
            searchMatrixKey={"combRep"}
          />
        ) : null}

        {/* custom views for specific enumerated types - taking also validity ranges from the bridging enumeration objects, ignore for nonListed subdomains */}
        {entityData &&
        ["Subdomain", "VariableSet"].indexOf(entityData.object.type) > -1 &&
        ("Subdomain" !== entityData.object.type ||
          entityData.object.isListed) ? (
          <GenericListRepresentation
            {...entityData}
            searchMatrixKey={"genListRep"}
          />
        ) : null}
      </React.Fragment>
    );
  };

  renderComparison = (entityData) => {
    return (
      <React.Fragment>
        {/* cube with cube structure items in a specific desired representation */}
        {entityData && entityData.object.type === "Cube" ? (
          <CubeCompare
            innerRef={this.cubeComparisonRef}
            cubeQueryWizardStore={this.props.cubeQueryWizardStore}
            {...entityData}
            searchMatrixKey={"cubeRep"}
          />
        ) : null}

        {/* combination with combination items in a specific desired representation */}
        {entityData && entityData.object.type === "Combination" ? (
          <CubeCompare {...entityData} searchMatrixKey={"combRep"} />
        ) : null}
      </React.Fragment>
    );
  };

  handleCollapse = () => {
    this.setState({
      mainHierarchyTree: !this.state.mainHierarchyTree,
    });
  };

  renderDomainMembersForVariable = (entityData) => {
    const {
      setCurrentPage,
      setPerPage,
      setSearchExpression,
      fetchEntityDetails,
      fetchingDataStatus,
    } = this.context;
    const definedOnEnumeratedDomain = entityData.definedOn.find(
      (item) => item.object.type === "Domain" && item.object.isEnumerated
    );
    const facetData =
      entityData &&
      entityData.navigationLookupResult &&
      entityData.navigationLookupResult.navigationLookupBuckets &&
      entityData.navigationLookupResult.navigationLookupBuckets
        .FacetEnumerations &&
      entityData.navigationLookupResult.navigationLookupBuckets
        .FacetEnumerations.objects
        ? entityData.navigationLookupResult.navigationLookupBuckets
            .FacetEnumerations.objects
        : [];

    if (definedOnEnumeratedDomain) {
      return (
        <>
          {(entityData.otherInformation &&
            entityData.otherInformation.mainMemberHierarchy &&
            entityData.otherInformation.mainMemberHierarchy.length > 0) ||
          fetchingDataStatus.get("Member Hierarchies") === true ? (
            <div className="related-objects custom-panel">
              <div className="custom-panel-heading">
                <h4 style={{ placeSelf: "center" }}>Members of the Domain</h4>
              </div>
              <div className="custom-panel-body related-types-list">
                <div className="custom-panel bucket-search">
                  <div
                    className="custom-panel-heading"
                    style={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    <h5 onClick={this.handleCollapse}>
                      Main Member Hierarchy of the Domain
                    </h5>
                    {fetchingDataStatus.get("Member Hierarchies") === true ? (
                      <div className="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <Collapse in={this.state.mainHierarchyTree}>
                    <div className="custom-panel-body related-types-list">
                      <Alert bsStyle="warning">
                        <div>
                          <Glyphicon glyph="info-sign" /> A Main Member
                          Hierarchy can be independent of the Framework (i.e.,
                          some Members might not be applicable to a selected
                          Framework).
                        </div>
                      </Alert>
                      {fetchingDataStatus.get("Member Hierarchies") === false &&
                        this.renderHierarchy({
                          ...entityData,
                          object: {
                            type: "MemberHierarchy",
                            tid: entityData.otherInformation
                              .mainMemberHierarchy[0].tid,
                          },
                          otherInformation: {
                            memberHierarchyTree:
                              entityData.otherInformation
                                .mainMemberHierarchyTree,
                          },
                        })}
                    </div>
                  </Collapse>
                </div>
              </div>
            </div>
          ) : null}
          {["Members"].map((type, key) => {
            return (
              <div className="related-objects custom-panel">
                <div className="custom-panel-body related-types-list">
                  <RelatedObjectItem
                    bucket={
                      entityData.navigationLookupResult.navigationLookupBuckets[
                        type
                      ]
                    }
                    key={key}
                    setCurrentPage={setCurrentPage}
                    setPerPage={setPerPage}
                    setSearchExpression={setSearchExpression}
                    fetchEntityDetails={() =>
                      fetchEntityDetails(undefined, undefined, type)
                    }
                    type={type}
                    typeView={this.context.entityData.item.object.type}
                  />
                </div>
              </div>
            );
          })}
        </>
      );
    } else {
      return facetData.length > 0 ? (
        <div>
          <FacetRepresentation entityData={entityData} />
        </div>
      ) : this.context !== this.props.popupStore ? (
        <div className="related-objects custom-panel">
          <div className="custom-panel-heading">
            <h4 style={{ placeSelf: "center" }}>{"Constraints"}</h4>
          </div>
          <div className="custom-panel-body related-types-list">
            <div className="alert alert-warning" role="alert">
              <span
                className="glyphicon glyphicon glyphicon-info-sign"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Info:</span> No generic constraints
              defined. Please note that specific constraints can be defined on a
              Cube level. Open a specific Cube from the related Cubes section
              below to find the related attribute’s constraint
            </div>
          </div>
        </div>
      ) : null;
    }
  };

  renderRelatedObjects = () => {
    // generic view from buckets
    const {
      getEntityData,
      setCurrentPage,
      setPerPage,
      setSearchExpression,
      fetchEntityDetails,
    } = this.context;

    return (
      <RelatedObjects
        {...getEntityData.item}
        innerRef={this.relatedRef}
        setCurrentPage={setCurrentPage}
        setPerPage={setPerPage}
        setSearchExpression={setSearchExpression}
        fetchEntityDetails={fetchEntityDetails}
      />
    );
  };

  renderHierarchy = (entityData) => {
    return (
      <VisContainer type={entityData.object.type} entityData={entityData} />
    );
  };

  renderMapping = () => {
    const { getEntityData } = this.context;
    return (
      <Mapping
        innerRef={this.cubeVariablesMappingRef}
        entityData={getEntityData.item}
      />
    );
  };

  renderMappingDefinition = () => {
    const { getEntityData } = this.context;
    return <MappingDefinition entityData={getEntityData.item} />;
  };

  renderTemplateRepresentation = () => {
    const { getEntityData } = this.context;
    return (
      <TemplateRepresentation
        innerRef={this.templateRepresentationRef}
        entityData={getEntityData.item}
        cubeQueryWizardStore={this.props.cubeQueryWizardStore}
      />
    );
  };
  renderFacetRepresentation = () => {
    const { getEntityData } = this.context;
    return <FacetRepresentation entityData={getEntityData.item} />;
  };
  static contextType = StoreContext;
  render() {
    const { getMetadata, filtersVisible, getUserProfileChanged } =
      this.props.searchStore;
    const { getEntityData, getAdditionalQueryParams, fetchingDataStatus } =
      this.context;
    const { display } = this.props;
    // need to add tid in render method otherwise the component doesn't rerender on tid changes
    // eslint-disable-next-line
    const { tid } = this.context;
    const entityData =
      getEntityData && getEntityData.item ? getEntityData.item : null;
    const { warnings, errors } = getEntityData || {};
    if (display === false) return <></>;
    return (
      <>
        {getMetadata &&
        getEntityData &&
        getAdditionalQueryParams &&
        Object.keys(getMetadata).length &&
        Object.keys(getEntityData).length ? (
          entityData &&
          entityData.object &&
          Object.keys(entityData.object).length ? (
            <div
              id="disableScrolls"
              className={`detail-view-pages ${
                filtersVisible ? "showFilters" : ""
              }`}
            >
              <React.Fragment>
                {errors
                  ? errors.map((error, index) => (
                      <Alert bsStyle="danger" key={index}>
                        <Glyphicon glyph="remove" /> {error}
                      </Alert>
                    ))
                  : ""}

                {warnings
                  ? warnings.map((warning, index) => (
                      <Alert bsStyle="warning" key={index}>
                        <Glyphicon glyph="warning-sign" /> {warning}
                      </Alert>
                    ))
                  : ""}

                {getUserProfileChanged === true ? (
                  <Alert bsStyle="warning" className="warning-user-profile">
                    <div>
                      <Glyphicon glyph="warning-sign" />
                      Your application profile has changed. Reload the page to
                      reflect possible changes.
                    </div>
                    <Button onClick={() => window.location.reload()}>
                      Reload
                    </Button>
                  </Alert>
                ) : null}

                {/* Button to show query wizard */}
                {entityData && entityData.object.type === "Cube" ? (
                  <CubeQueryWizardButton
                    onClick={this.handleQueryWizardButtonClick}
                  />
                ) : null}

                {this.renderDescriptiveMetadata(entityData)}
                {entityData.object.type === "Cube" ? (
                  <div ref={this.navRef}>
                    <ActivityNavigation
                      scrollTargets={this.scrollTargets}
                      type={entityData.object.type}
                    />
                  </div>
                ) : null}
                {entityData.object.type === "Cube"
                  ? this.renderTemplateRepresentation()
                  : null}

                {entityData && entityData.object.type === "CubeLink" ? (
                  <CubeLinkVariables
                    {...entityData}
                    searchMatrixKey={"memberLink"}
                    cubeQueryWizardStore={this.props.cubeQueryWizardStore}
                  />
                ) : null}

                {entityData.object.type === "CubeHierarchy" ? (
                  <React.Fragment>
                    {this.renderHierarchy(entityData)}
                  </React.Fragment>
                ) : null}

                {entityData.object.type === "MappingDefinition" &&
                entityData.object.mappingType === "E" ? (
                  <React.Fragment>
                    {this.renderMappingDefinition()}
                  </React.Fragment>
                ) : null}

                {entityData.object.type === "Domain" ? (
                  <React.Fragment>
                    {this.renderFacetRepresentation()}
                  </React.Fragment>
                ) : null}

                {entityData.object.type === "Subdomain" ? (
                  <React.Fragment>
                    {this.renderFacetRepresentation()}
                  </React.Fragment>
                ) : null}

                {entityData.object.type === "MemberHierarchy" ? (
                  <div className="mapping custom-panel">
                    <div
                      className="custom-panel-heading"
                      style={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      <h4>Hierarchy Representation</h4>
                      {fetchingDataStatus.get("Member Hierarchies") === true ? (
                        <div className="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {fetchingDataStatus.get("Member Hierarchies") === false ? (
                      <div className="custom-panel-body">
                        {this.renderHierarchy(entityData)}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : null}

                {entityData.object.type === "Domain" &&
                ((entityData.otherInformation &&
                  entityData.otherInformation.mainMemberHierarchy &&
                  entityData.otherInformation.mainMemberHierarchy.length > 0) ||
                  fetchingDataStatus.get("Member Hierarchies") === true) ? (
                  <div className="mapping custom-panel">
                    <div
                      className="custom-panel-heading"
                      style={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      <h4>Main Member Hierarchy of the Domain</h4>
                      {fetchingDataStatus.get("Member Hierarchies") === true ? (
                        <div className="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="custom-panel-body related-types-list">
                      {fetchingDataStatus.get("Member Hierarchies") === false &&
                        this.renderHierarchy({
                          ...entityData,
                          object: {
                            type: "MemberHierarchy",
                            tid: entityData.otherInformation
                              .mainMemberHierarchy[0].tid,
                          },
                          otherInformation: {
                            memberHierarchyTree:
                              entityData.otherInformation
                                .mainMemberHierarchyTree,
                          },
                        })}
                    </div>
                  </div>
                ) : null}

                {entityData.object.type === "Member" &&
                ((entityData.otherInformation &&
                  entityData.otherInformation.mainMemberHierarchy &&
                  entityData.otherInformation.mainMemberHierarchy.length > 0) ||
                  fetchingDataStatus.get("Member Hierarchies") === true) ? (
                  <div className="mapping custom-panel">
                    <div
                      className="custom-panel-heading"
                      style={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      <h4>Main Member Hierarchy of the Domain</h4>
                      {fetchingDataStatus.get("Member Hierarchies") === true ? (
                        <div className="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="custom-panel-body related-types-list">
                      {fetchingDataStatus.get("Member Hierarchies") === false &&
                        this.renderHierarchy({
                          ...entityData,
                          object: {
                            type: "MemberHierarchy",
                            tid: entityData.otherInformation
                              .mainMemberHierarchy[0].tid,
                          },
                          otherInformation: {
                            memberHierarchyTree:
                              entityData.otherInformation
                                .mainMemberHierarchyTree,
                          },
                        })}
                    </div>
                  </div>
                ) : null}

                {entityData.object.type === "Variable" ? (
                  <React.Fragment>
                    {this.renderDomainMembersForVariable(entityData)}
                  </React.Fragment>
                ) : (
                  ""
                )}

                {entityData.object.type === "Subdomain" ||
                entityData.object.type === "VariableSet" ||
                entityData.object.type === "Combination" ? (
                  <React.Fragment>
                    {this.renderRepresentation(entityData)}
                    {entityData.object.type === "Combination" ? (
                      <>
                        {!EnvironmentUtils.isBirdApp() &&
                          this.renderComparison(entityData)}
                        <CombinationRepresentation
                          {...entityData}
                          mapped={true}
                          searchMatrixKey={"combRepMapped"}
                        />
                      </>
                    ) : null}
                    {this.renderRelatedCubes(entityData)}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {this.renderRelatedCubes(entityData)}
                    {this.renderRepresentation(entityData)}
                    {!EnvironmentUtils.isBirdApp() &&
                      this.renderComparison(entityData)}
                  </React.Fragment>
                )}

                {entityData &&
                entityData.object.type === "Cube" &&
                this.entityDataHasCubeLinks(entityData) ? (
                  <MatchingCubes
                    innerRef={this.LinkedCubesRef}
                    {...entityData}
                    searchMatrixKey={"cubeLink"}
                  />
                ) : null}

                {this.renderHintOnProfileForNoRelatedData(entityData)}

                {!EnvironmentUtils.isBirdApp() &&
                  (entityData.object.type === "Combination" ||
                    entityData.object.type === "Cube") && (
                    <SimilarObjects
                      innerRef={this.similarObjectsRef}
                      entityDetails={entityData}
                      entityDetailsParams={getEntityData.params}
                      multiSearchStore={this.props.multiSearchStore}
                    />
                  )}

                {entityData.object.type === "Cube" &&
                entityData.otherInformation &&
                entityData.otherInformation.mappingsForCube &&
                entityData.otherInformation.mappingsForCube.length > 0 ? (
                  <React.Fragment>{this.renderMapping()}</React.Fragment>
                ) : null}
                {this.renderRelatedObjects()}
              </React.Fragment>
            </div>
          ) : (
            <div>Nothing found</div>
          )
        ) : (
          <>
            {fetchingDataStatus.get("CubeHierarchy") === true && (
              <div
                className={`detail-view-pages ${
                  filtersVisible ? "showFilters" : ""
                }`}
              >
                <div className="descriptive-metadata custom-panel">
                  <div className={`custom-panel-heading ${"reference"}`}>
                    <h4>Data Model</h4>
                  </div>
                </div>

                <div>
                  Loading...
                  <div className="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </div>
            )}
            {fetchingDataStatus.length > 0 && (
              <div>
                Loading...
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            )}
          </>
        )}
      </>
    );
  }
}
